import React, {useState} from 'react';
import {Button, Input, Modal, Table} from 'semantic-ui-react';
import {withNamespaces, WithNamespaces} from 'react-i18next';
import {
  FilterObjectComponentProps,
  InfinityScrollComponentProps, withFilterObject,
  withInfinityScrollHandlers
} from '../../components/DataTable/dataService';
import RestClient from '../../../../lib/RestClient';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import InfiniteScroll from 'react-infinite-scroller';

interface AccountSelectionButtonProps extends WithNamespaces {
  accountType: string;
  value?: string;

  onChange(accType: string): void;
}

export const AccountSelectionButton = withNamespaces()((props: AccountSelectionButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonContent = props.value && props.value.length > 0 ? props.t('Inventory.Account') + ' ' + props.value : props.t('Inventory.ChooseAccount');
  return (
      <>
        <Button onClick={() => setIsOpen(true)}
                content={buttonContent} />
         {isOpen && (
             <AccountSelectionModal
                  accountType={props.accountType}
                  onClose={() => setIsOpen(false)}
                  onSelect={acc => {
                    props.onChange(acc);
                    setIsOpen(false);
                  }}
                />
         )}
      </>
  );
});

interface AccountSelectionModalProps extends WithNamespaces {
  accountType: string;

  onSelect(account: string): void;
  onClose(): void;
}
const AccountSelectionModal = withNamespaces()((props: AccountSelectionModalProps) => {
  const dataService = {
    loadPage: (page: number, sortColumn: string | undefined, sortOrder: 'ASC' | 'DESC' | undefined, filter: { [key: string]: any }, size = 500) => {
      return RestClient.get('/advanceData/accounts', {
        accountType: props.accountType,
        sortBy: sortColumn,
        sortDirection: sortOrder,
        page: page,
        count: size,
        filter: filter.filter});
    }
  };
  return (
      <Modal open={true}>
        <Modal.Header>{props.t("Inventory.ChooseAccount")}</Modal.Header>
        <Modal.Content scrolling>
          <AccountSelectionList
            sortDirection="ASC"
            sortColumn={props.accountType === 'customer' ? 'data.KundeRDH' : 'data.AnliefererRDH'}
            dataService={dataService}
            accountType={props.accountType}
            onSelect={props.onSelect}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button default onClick={()=> props.onClose()}>
            {props.t("Common.Cancel")}
          </Button>
        </Modal.Actions>
      </Modal>
  );
});

interface AccountSelectionListProps extends InfinityScrollComponentProps, FilterObjectComponentProps, WithNamespaces {
  accountType: string;
  onSelect(account: string): void;
}

const AccountSelectionList = withFilterObject(withInfinityScrollHandlers(withNamespaces()((props: AccountSelectionListProps) => {
  if(props.loadingInitial) {
    return <LoadingContainer showLogo={false} />;
  }

  return (<>
      <p>{props.t("Inventory.Found$dAccounts", {count: props.totalItems})}</p>
      <Input icon={'search'} placeholder={props.t("Forms.Placeholder.Search")}
             type={"text"}
             onChange={(_,data) => props.handleFilterChange('filter', data.value)}
             value={props.filterObject.filter || ''}
      />

    <Table celled striped sortable >
      <Table.Header id={"tableHeader"}>
        <Table.Row>
          <Table.HeaderCell singleLine
          >{props.t("Inventory.Account")}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <InfiniteScroll
          pageStart={0}
          loadMore={props.loadMore}
          hasMore={props.totalPages > props.page}
          threshold={500}
          useWindow={false}
          element={'tbody'}
          style={{height: "50vh"}}
      >
        {props.data && (
            <Table.Row>
              <Table.Cell style={{cursor: 'pointer'}} onClick={() => props.onSelect('')}>{props.t('Common.All')}</Table.Cell>
            </Table.Row>
        )}
        {props.data && props.data.map((dataRow: any) => {
          const accountNr = props.accountType === 'customer'
                  ? dataRow.data.KundeRDH
                  : dataRow.data.AnliefererRDH;
          return (
              <Table.Row>
                <Table.Cell style={{cursor: "pointer"}} onClick={ ()=> props.onSelect(accountNr) }>{accountNr}</Table.Cell>
              </Table.Row>
          )
        })}
      </InfiniteScroll>
    </Table>

    {props.loadingMore && <div style={{textAlign:'center', height:'3em'}}><LoadingSpinner /></div>}
  </>);
})));